import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import SiteList from "components/SiteList";

function getTextFilter() {
	function TextFilter() {}

	TextFilter.prototype.init = function(params) {
		this.valueGetter = params.valueGetter;
		this.filterText = null;
		this.setupGui(params);
	};

	// not called by ag-Grid, just for us to help setup
	TextFilter.prototype.setupGui = function(params) {
		this.gui = document.createElement("div");
		this.gui.innerHTML =
			'<div style="padding: 4px;">' +
			'<div style="font-weight: bold;">Search for sites</div>' +
			'<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="Site url..."/></div>' +
			'<div style="margin-top: 5px; width: 200px;">Enter the sites that you want to search for</div>' +
			"</div>";

		this.eFilterText = this.gui.querySelector("#filterText");
		this.eFilterText.addEventListener("changed", listener);
		this.eFilterText.addEventListener("paste", listener);
		this.eFilterText.addEventListener("input", listener);
		// IE doesn't fire changed for special keys (eg delete, backspace), so need to
		// listen for this further ones
		this.eFilterText.addEventListener("keydown", listener);
		this.eFilterText.addEventListener("keyup", listener);
		this.filterChangedCallback = params.filterChangedCallback;

		var that = this;

		function listener(event) {
			that.filterText = event.target.value;
			params.filterChangedCallback();
		}
	};

	TextFilter.prototype.getGui = function() {
		return this.gui;
	};

	TextFilter.prototype.doesFilterPass = function(params) {
		// make sure each word passes separately, ie search for firstname, lastname
		var passed = true;
		var valueGetter = this.valueGetter;
		var value = valueGetter(params);
		if (
			value
				.toString()
				.toLowerCase()
				.indexOf(this.filterText.toLowerCase()) < 0
		) {
			passed = false;
		}
		if (passed && this.filterText.toLowerCase() == "wordpress.com") {
			// console.log(params);
		}
		return passed;
	};

	TextFilter.prototype.isFilterActive = function() {
		var isActive =
			this.filterText !== null &&
			this.filterText !== undefined &&
			this.filterText !== "";
		return isActive;
	};

	TextFilter.prototype.getApi = function() {
		var that = this;
		return {
			getModel: function() {
				var model = { value: that.filterText.value };
				return model;
			},
			setModel: function(model) {
				that.eFilterText.value = model.value;
			}
		};
	};

	TextFilter.prototype.getModelAsString = function(model) {
		return model ? model : "";
	};

	TextFilter.prototype.getModel = function() {
		return this.filterText;
	};
	// lazy, the example doesn't use setModel()
	TextFilter.prototype.setModel = function(params) {
		if (!params) {
			this.filterText = "";
			this.eFilterText.value = "";
			this.filterChangedCallback();
		}
	};

	return TextFilter;
}

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

var siteStatusRenderer = function(params) {
	if (params.value == "SUCCESS") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(17, 119, 51);">Success</div>';
	} else if (params.value == "FAILED") {
		return '<div data-show="true" class="ant-tag ant-tag-has-color" style="background-color: rgb(217, 33, 32);">Failed</div>';
	} else if (params.value == "NONE") {
		return "";
	} else if (params.value == "RUNNING") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(16, 142, 233);">Running</div>';
	} else {
		return "<span></span>";
	}
};

function strcmp(a, b) {
	return a < b ? -1 : a > b ? 1 : 0;
}

@inject("rootStore")
@observer
class SitesTab extends Component {
	createColumnDefs(props) {
		return [
			{
				headerName: "Platform",
				field: "platform",
				editable: false,
				hide: false,
				rowGroupIndex: 0
			},
			{
				field: "id",
				headName: "ID",
				editable: false,
				hide: true
			},
			// {
			// 	headerName: "Site",
			// 	field: "id.siteId",
			// 	width: 267,
			// 	editable: false,
			// 	filter: getTextFilter()
			// },
			{
				headerName: "Status",
				field: "status",
				width: 150,
				editable: false,
				cellRenderer: siteStatusRenderer,
				filter: "agSetColumnFilter",
				filterParams: {
					values: ["NONE", "SUCCESS", "FAILED", "RUNNING"]
				},
				cellClass: function() {
					return "alphabet";
				}
			},
			{
				headerName: "DA",
				field: "pr",
				width: 100,
				editable: false,
				floatCell: true,
				filter: "agNumberColumnFilter",
				filterParams: {
					filterOptions: ["greaterThanOrEqual"],
					cellHeight: 20,
					newRowsAction: "keep"
				}
			},
			{
				headerName: "Dofollow",
				field: "dofollow",
				width: 150,
				editable: false,
				cellRenderer: doFollowRenderer,
				filter: "agSetColumnFilter"
			},
			{
				headerName: "Progress",
				field: "waitInfo",
				width: 250,
				editable: false,
				suppressFilter: true,
				suppressMenu: true,
				suppressSorting: true
			}
		];
		// console.log("Create column defs");
		// const gridDefs = {
		// 	columnDefs: [
		// 		{
		// 			headerName: "Platform",
		// 			field: "platform",
		// 			editable: false,
		// 			hide: true,
		// 			rowGroupIndex: 0
		// 		},
		// 		{
		// 			field: "id",
		// 			headName: "ID",
		// 			editable: false,
		// 			hide: true
		// 		},
		// 		{
		// 			headerName: "Site",
		// 			field: "id.siteId",
		// 			width: 267,
		// 			editable: false,
		// 			filter: getTextFilter()
		// 		},
		// 		{
		// 			headerName: "Status",
		// 			field: "status",
		// 			width: 150,
		// 			editable: false,
		// 			cellRenderer: siteStatusRenderer,
		// 			filter: "agSetColumnFilter",
		// 			filterParams: {
		// 				values: ["NONE", "SUCCESS", "FAILED", "RUNNING"]
		// 			},
		// 			cellClass: function() {
		// 				return "alphabet";
		// 			}
		// 		},
		// 		{
		// 			headerName: "DA",
		// 			field: "pr",
		// 			width: 100,
		// 			editable: false,
		// 			floatCell: true,
		// 			filter: "agNumberColumnFilter",
		// 			filterParams: {
		// 				filterOptions: ["greaterThanOrEqual"],
		// 				cellHeight: 20,
		// 				newRowsAction: "keep"
		// 			}
		// 		},
		// 		{
		// 			headerName: "Dofollow",
		// 			field: "dofollow",
		// 			width: 150,
		// 			editable: false,
		// 			cellRenderer: doFollowRenderer,
		// 			filter: "agSetColumnFilter"
		// 		},
		// 		{
		// 			headerName: "Progress",
		// 			field: "waitInfo",
		// 			width: 250,
		// 			editable: false,
		// 			suppressFilter: true,
		// 			suppressMenu: true,
		// 			suppressSorting: true
		// 		}
		// 	],
		// 	groupDefaultExpanded: -1,
		// 	autoGroupColumnDef: {
		// 		headerName: "Platform",
		// 		field: "platform",
		// 		headerCheckboxSelection: () => {
		// 			console.log("header check box selection " + props.ui.editing);
		// 			return props.ui.editing;
		// 		},
		// 		// headerCheckboxSelectionFilteredOnly: true,
		// 		width: 300,
		// 		editable: false,
		// 		cellRenderer: "agGroupCellRenderer",
		// 		cellRendererParams: {
		// 			checkbox: true,
		// 			readOnly: () => {
		// 				return !props.ui.editing;
		// 			}
		// 		},
		// 		suppressSorting: true
		// 	},
		// 	rowSelection: "multiple"
		// };
		// return gridDefs;
	}

	getRowNodeId = (data) => {
		return data.id.module + "_" + data.siteId;
	}

	getRowData = () => {
		return this.siteList.getRowData();
	}

	render() {
		const {
			rootStore: { projectStore }
		} = this.props;				
		return (
			<div
				style={{
					width: "100%",
					height: window.screen.height * 3 / 4
				}}
			>
				<SiteList
					ui={projectStore.ui}
					sites={projectStore.sites.slice()}
					columnDefs={this.createColumnDefs()}
					getRowNodeId={this.getRowNodeId}
					ref={siteList => {
						this.siteList = siteList;
					}}
				/>
			</div>
		);
	}
}

export default SitesTab;
